import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import { BuildingFlags } from '@/roc/building/BuildingTemplate';
import Happiness from "@/roc/effects/CultureBonus/Happiness";
const _productionRates = {
    3: { short: 1700, medium: null, long: null },
    6: { short: 2200, medium: 3000, long: 4100 },
    9: { short: 3800, medium: 5200, long: 7200 },
    12: { short: 5600, medium: 7700, long: 10600 },
    15: { short: 6660, medium: 9170, long: 12600 },
    18: { short: 7790, medium: 10700, long: 14700 },
    21: { short: 9090, medium: 12400, long: 17200 },
    24: { short: 10500, medium: 14300, long: 19900 },
    27: { short: 11900, medium: 16200, long: 22600 },
    30: { short: 13600, medium: 18400, long: 25700 },
    33: { short: 15400, medium: 21000, long: 29200 },
    36: { short: 17500, medium: 23800, long: 33200 },
    39: { short: 20000, medium: 28000, long: 39200 },
    42: { short: 27500, medium: 40600, long: 60200 },
};
const LuxuriousFarm = {
    id: "6",
    name: "Luxurious Farm",
    width: 3,
    height: 3,
    type: BuildingType.FARM,
    era: "stoneAge",
    icon: "Food",
    minLevel: 3,
    maxLevel: BuildingMaxLevel.THREE_OFF,
    url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Farms/Luxurious_Farm',
    flags: BuildingFlags.LUXURIOUS,
    counts: {
        stoneAge: 1,
        bronzeAge: 3,
        minoanEra: 4,
        classicGreece: 4,
        earlyRome: 5,
        romanEmpire: 6,
        byzantineEra: 7,
        ageOfTheFranks: 7,
        feudalAge: 7,
        iberianEra: 8,
        kingdomOfSicily: 8,
        highMiddleAges: 8,
        earlyGothicEra: 8,
        lateGothicEra: 8,
    },
    effects: Effects.create([
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 3) {
                return 1;
            }
            if (level <= 6) {
                return 2;
            }
            if (level <= 9) {
                return 3;
            }
            return 4;
        }), [], ProductionDuration.asFlat(30 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].short;
        }).withOutput(ProductionOutputType.FOOD)),
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 3) {
                return 1;
            }
            if (level <= 6) {
                return 2;
            }
            if (level <= 9) {
                return 3;
            }
            return 4;
        }), [], ProductionDuration.asFlat(1 * 60 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].medium;
        }).withOutput(ProductionOutputType.FOOD)),
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 3) {
                return 1;
            }
            if (level <= 6) {
                return 2;
            }
            if (level <= 9) {
                return 3;
            }
            return 4;
        }), [], ProductionDuration.asFlat(2 * 60 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].long;
        }).withOutput(ProductionOutputType.FOOD)),
        new Happiness({
            stoneAge: [80, 170, 330],
            bronzeAge: [130, 250, 500],
            minoanEra: [170, 330, 670],
            classicGreece: [220, 450, 890],
            earlyRome: [280, 560, 1120],
            romanEmpire: [330, 670, 1340],
            byzantineEra: [390, 780, 1560],
            ageOfTheFranks: [470, 950, 1900],
            feudalAge: [560, 1120, 2230],
            iberianEra: [670, 1340, 2680],
            kingdomOfSicily: [810, 1620, 3230],
            highMiddleAges: [980, 1950, 3900],
            earlyGothicEra: [1170, 2340, 4680],
            lateGothicEra: [1360, 2730, 5460],
        }),
    ]),
};
export default LuxuriousFarm;
